import { __awaiter } from "tslib";
import { log } from "../utils";
var JetStreamToCirrusMessageType;
(function (JetStreamToCirrusMessageType) {
    JetStreamToCirrusMessageType["EndMultiSession"] = "endMultiSession";
    JetStreamToCirrusMessageType["StreamingConfig"] = "streamingConfig";
    JetStreamToCirrusMessageType["StillActive"] = "stillActive";
    JetStreamToCirrusMessageType["Broadcast"] = "broadcast";
})(JetStreamToCirrusMessageType || (JetStreamToCirrusMessageType = {}));
export default class CirrusApi {
    constructor(configService, timeoutTrackingService, datachannelHandler, httpClient) {
        this.connectionIsActive = false;
        this.broadcastHandlers = new Array();
        this.configService = configService;
        this.timeoutTrackingService = timeoutTrackingService;
        this.datachannelHandler = datachannelHandler;
        this.httpClient = httpClient;
    }
    setCirrusIp(cirrusIp) {
        this.cirrusUrl = `https://${cirrusIp}:80`;
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            log.debug("Connecting to signaling server");
            (_a = this.webrtcPlayer) === null || _a === void 0 ? void 0 : _a.on("aveMessage", (datachannelResponse) => this.datachannelHandler.handleAveResponse(datachannelResponse));
            (_b = this.webrtcPlayer) === null || _b === void 0 ? void 0 : _b.on("cirrusBroadcast", this.cirrusBroadcastMessageHandler.bind(this));
            this.timeoutTrackingService.registerInactivityResetCallback(this.sendStillActive.bind(this));
            this.sendStreamingConfig();
        });
    }
    close() {
        log.debug("Disconnecting from signaling server");
        this.timeoutTrackingService.clearUserActivityTrackingInterval();
        this.connectionIsActive = false;
    }
    isConnectionActive() {
        return this.connectionIsActive;
    }
    setConnectionActive() {
        this.connectionIsActive = true;
    }
    sendEndMultiSession(token) {
        var _a;
        (_a = this.webrtcPlayer) === null || _a === void 0 ? void 0 : _a.sendSignalingMessage({ type: JetStreamToCirrusMessageType.EndMultiSession, token });
    }
    sendStillActive() {
        var _a;
        (_a = this.webrtcPlayer) === null || _a === void 0 ? void 0 : _a.sendSignalingMessage({ type: JetStreamToCirrusMessageType.StillActive });
    }
    sendBroadcast(message) {
        var _a;
        (_a = this.webrtcPlayer) === null || _a === void 0 ? void 0 : _a.sendSignalingMessage({
            type: JetStreamToCirrusMessageType.Broadcast,
            message: JSON.stringify(message),
        });
    }
    onBroadcast(broadcastHandler) {
        this.broadcastHandlers.push(broadcastHandler);
    }
    sendStreamingConfig() {
        var _a;
        const streamingConfig = this.configService.getStreamingConfig();
        log.info(`Sending streaming config to Cirrus, config = ${JSON.stringify(streamingConfig)}`);
        (_a = this.webrtcPlayer) === null || _a === void 0 ? void 0 : _a.sendSignalingMessage({
            type: JetStreamToCirrusMessageType.StreamingConfig,
            streamingConfig,
        });
    }
    fetchImage(imagePath) {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = { imagePath };
            try {
                const response = yield this.httpClient.getArrayBuffer(`${this.cirrusUrl}/image`, headers);
                return response.body;
            }
            catch (error) {
                const message = `Failed downloading the image with path=${imagePath}`;
                log.error(message, error);
                throw new Error(message);
            }
        });
    }
    cirrusBroadcastMessageHandler(message) {
        log.debug("Received Cirrus broadcast message. Message=", message);
        this.broadcastHandlers.forEach((handler) => handler(JSON.parse(message)));
    }
}
//# sourceMappingURL=cirrus-api.js.map